<template>
  <div>
    <template v-for="condition in conditionsList">
      <div
        :key="condition.text"
        :class="{
          'list-item': true,
          'list-item--error': !condition.test_res,
          'list-item--success': condition.test_res
        }"
      >
        {{ condition.text }}
      </div>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'Conditions',
    props: {
      valid_result: {
        type: Array,
        default: () => []
      }
    },
    data: () => ({}),
    computed: {
      conditionsList() {
        return [
          {
            text: this.$t('core.reset_password.six_symbols'),
            test_res: this.valid_result[0]
          },
          {
            text: this.$t('core.reset_password.one_number'),
            test_res: this.valid_result[1]
          },
          {
            text: this.$t('core.reset_password.one_uppercase_letter'),
            test_res: this.valid_result[2]
          },
          {
            text: this.$t('core.reset_password.one_lowercase_letter'),
            test_res: this.valid_result[3]
          },
          {
            text: this.$t('core.reset_password.password_spaces'),
            test_res: this.valid_result[4]
          },
          {
            text: this.$t('core.reset_password.matched_passwords'),
            test_res: this.valid_result[5]
          }
        ];
      }
    },

  };
</script>
<style lang="scss">
  .list-item {
    &::before {
      content: '\2022';
    }

    &--error {
      color: $red;
    }
    &--success {
      color: $green;
    }
  }
</style>
